<div class="stat" *ngFor="let stat of data">
  <div class="header">
    <h3>{{ stat.title }}</h3>
    <p class="value">{{ stat.value }} <span class="unit">{{ stat.unit }}</span></p>
  </div>
  <div class="detail">
    <p><span class="success">{{ stat.shots.success }}</span> <span class="total">/ {{ stat.shots.total }}</span></p>
    <p><span class="accuracy color {{ getAccuracyColorClass(stat.shots.accuracy) }}"></span>{{ stat.shots.accuracy }} %</p>
  </div>
</div>
